ready(function(){
	const bannerShape = document.querySelector('.banner.type--shape');
	const bannerShapeContentWrapper = document.querySelector('.banner.type--shape .content__wrapper');
	if (bannerShape) {
		bannerShape.addEventListener('click', function() {
			bannerShapeContentWrapper.classList.toggle('opacity-0');
		});
	}
});